import template from './urban-total-area-room.jade';
import validation from './../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.urbanTotalAreaRoom', [])
  .directive('cianAfAboutObjectUrbanTotalAreaRoom', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'deviceService',
      'store',
      function (deviceService, store) {
        this.isMobile = deviceService.isMobile;
        this.areaMax = 10000000;
        this.getKitchenAndLivingArea = () => {
          return (
            (Number(this.ad.livingArea) || 0) + (Number(this.ad.kitchenArea) || 0) + (Number(this.ad.roomArea) || 0)
          ); // значение может быть не задано, поэтому через 'или'
        };
        this.validation = validation(this.form, 'urbanTotalAreaRoom', {
          parse: 'Введите число',
          required: 'Укажите общую площадь',
          min: 'Общая площадь объекта не должна быть меньше суммы площадей кухни и комнаты',
          max: 'Допустимо не более 7 символов',
        });

        let trackedValue;

        this.handleBlur = () => {
          const value = this.ad.totalArea;

          if (value && value !== trackedValue) {
            const state = store.getState();
            const category = selectAnalyticsOfferStatus(state);

            trackRequiredFieldFill(category, 'total_area');
            trackedValue = value;
          }
        };
      },
    ],
    controllerAs: 'urbanTotalAreaRoom',
    template,
  })).name;
